import React from 'react';
import Plot from 'react-plotly.js';

const FOAK = () => {
  const trace1 = {
    x: ['Vogtle', 'Flamanville', 'Hinkley', 'Olkiluoto'],
    y: [14, 3.5, 24, 3.5],
    name: 'Initial Price Estimate (Billions)',
    type: 'bar',
    marker: {
      color: '#3bf657ff'
    }
  };

  const trace2 = {
    x: ['Vogtle', 'Flamanville', 'Hinkley', 'Olkiluoto'],
    y: [21, 10.5, 21, 9.2],
    name: 'Cost Overuns (Billions)',
    type: 'bar',
    marker: {
      color: '#eb7100ff'
    }
  };


  const data = [trace1, trace2];


  return (
    <div className="w-full h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="w-full max-w-4xl bg-white rounded-lg shadow-lg p-6">
        <Plot
          data={data}
      layout={{

        title: "FOAK",
        xaxis: { title: "Month", fixedrange: true },
        yaxis: { title: "LCOE ($/kWh)", fixedrange: true },
        legend: { orientation: "h" },
        autosize: true,
        margin: { t: 50, b: 50, l: 50, r: 50 },
        barmode: 'stack',
        }}
      useResizeHandler={true}
  style={{ width: "100%", height: "100%" }}
  config={{ displayModeBar: false, scrollZoom: false }}
          className="w-full h-96"
        />
      </div>
    </div>
  );
};

export default FOAK;